<template>
	<section v-editable="blok" class="container" data-component="ListingIntroductoryBanner">
		<div class="grid grid-cols-5 sm:grid-cols-4 ring-1 ring-border-tertiary rounded-2.5xl overflow-hidden shadow-md md:shadow-sm">
			<div
				class="col-span-3 sm:col-span-3"
				:class="selectedHypermarket ? 'p-6 md:p-8 pb-4 md:pb-6' : 'px-6 md:px-8 py-16'"
			>
				<PageHeadingWithHypermarket
					v-if="selectedHypermarket"
					:heading="heading"
					information-text="Informace o&nbsp;produktech se vztahují k&nbsp;pobočce"
					show-links-in-selection-banner
				/>
				<h1 v-else class="typo-h1 mb-2">
					{{ heading }}
				</h1>
				<div v-if="blok.infoText === 'automatic' && automaticInfoText" class="typo-body-s md:text-base text-body-tertiary flex gap-2 items-center" v-html="automaticInfoText" />
				<div v-else-if="blok.text" class="typo-body-s md:text-base text-body-tertiary flex gap-2 items-center">
					<FeatherIcon v-if="blok.icon?.icon && blok.infoText === 'manual-with-icon'" :icon="blok.icon.icon" class="w-3 h-3" />
					{{ blok.text }}
				</div>
			</div>
			<div class="col-span-2 sm:col-span-1 flex relative items-center">
				<NuxtPicture
					v-if="blok.image?.filename"
					:provider="isStatic ? 'ipx' : 'storyblok'"
					:modifiers="storyblokFocusModifiers(blok.image.focus)"
					:src="blok.image.filename"
					:alt="blok.image.alt || ''"
					sizes="xs:20vw sm:20vw md:20vw lg:20vw xl:20vw xxl:20vw inf:280px"
					:img-attrs="{class:'object-cover w-full h-full absolute top-[50%] translate-y-[-50%] max-h-48 clip-style'}"
					width="280"
					height="192"
				/>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
	import type {ListingIntroductoryBannerStoryblok} from '@/storyblok/types';

	type Props = {
		blok: Pick<ListingIntroductoryBannerStoryblok, 'header'> & Partial<ListingIntroductoryBannerStoryblok>
		automaticInfoText?: string
		isStatic?: boolean
		headingTag?: string
	};

	const props = withDefaults(defineProps<Props>(), {
		automaticInfoText: '',
		isStatic: false,
		headingTag: 'h2',
	});

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket} = storeToRefs(hypermarketsStore);

	const heading = computed(() => selectedHypermarket.value
		? props.blok.header
		: `Objednávka výrobků z ${props.blok.header} Globus`);
</script>
